import React from 'react';

export default React.memo(function Range({ className = '', ...props }) {
  return (
    <input type={'range'} className={`${className}`} {...props} />
  );
})
